import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'btoa', standalone: false })
export class BtoAPipe implements PipeTransform {
    transform(value: string): string {
        return btoa(unescape(encodeURIComponent(value)));
    }
}
